import GlobalStyle from '../../utils/sass/global.module.scss'
import { ChatBox, Files, Messages } from '../../components/chat';
import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAdminSupport } from '../../store/chat/chatActions';
import { useParams } from 'react-router';
import { FiChevronLeft } from 'react-icons/fi';
import { SocketContext } from '../../utils/socketConfig';
import { Toaster } from 'react-hot-toast';

const chatCol =
    'h-[800px] max-md:max-h-screen shrink-0 bg-white p-5 rounded-[20px]';
const messagesCol = `${chatCol} w-[350px] max-md:max-w-[calc(100%-40px)]`;
const chatMainCol = `${chatCol} flex flex-1 min-w-0 w-full items-center justify-center lg:w-[calc(100%-350px)]`;
const filesCol = `${chatCol} hidden w-[350px] lg:block`;

const Chat = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [defaultChat, setDefalultChat] = useState(null);
    const dispatch = useDispatch();
    const { id } = useParams()
    const [mobileListOpen, setMobileListOpen] = useState(true)
    const socket = useContext(SocketContext);

    useEffect(() => {
        setIsLoading(true)
        if (id) {
            setDefalultChat(id)
        }
        dispatch(getAdminSupport())
            .then((v) => {
                setIsLoading(false)
            })
    }, []);

    return (
        <div>
            <h1 className={GlobalStyle.pageTitle}>Chat</h1>
            <Toaster />
            <div className="flex gap-5 relative overflow-hidden">
                <div className={`${messagesCol} shadow-md lg:shadow-none absolute z-10 top-0 lg:relative transition-transform duration-300 ease-linear ${mobileListOpen ? "translate-x-0" : " -translate-x-full"} xl:translate-x-0`}>
                    <button className='lg:hidden absolute bg-white ml-2 h-8 w-8 grid place-items-center rounded-lg shadow-md left-[100%]' onClick={() => setMobileListOpen((x) => !x)}>
                        <FiChevronLeft className={`text-nt-blue right-0 transition-transform delay-150 duration-300 ${!mobileListOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {socket != null ? <Messages defaultChat={defaultChat} />: null}
                </div>
                <div className={chatMainCol}>
                    <ChatBox />
                </div>
                <div className={filesCol}>
                    <Files />
                </div>
            </div>
        </div>
    )
}

export default Chat;
